import { isRetryable, StoryFailure } from '../domain/story'

const delays = [1000, 3000, 10_000] as const

export function retryDelay(error: unknown, attempt: number): number | null {
  const delay = delays[attempt]
  if (!isRetryable(error) || delay === undefined) return null
  return Math.max(delay, error instanceof StoryFailure ? error.retryAfterMs : 0)
}
